/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Plan_Visibility_CtaInputs */

const et_plan_visibility_cta = /** @type {(inputs: Plan_Visibility_CtaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Soovin rohkem nähtavust`)
};

const en_plan_visibility_cta = /** @type {(inputs: Plan_Visibility_CtaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`I want more visibility`)
};

/**
* | output |
* | --- |
* | "I want more visibility" |
*
* @param {Plan_Visibility_CtaInputs} inputs
* @param {{ locale?: "et" | "en" }} options
* @returns {LocalizedString}
*/
export const plan_visibility_cta = /** @type {((inputs?: Plan_Visibility_CtaInputs, options?: { locale?: "et" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Plan_Visibility_CtaInputs, { locale?: "et" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "et") return et_plan_visibility_cta(inputs)
	return en_plan_visibility_cta(inputs)
});